import ColorBlock from 'components/ColorBlock';
import ColorGrid from 'components/ColorGrid';
import React from 'react';
export default {
  ColorBlock,
  ColorGrid,
  React
};